import axios from "../requests/axios.js";
export default (url) => axios.get(url).then(({ data }) => data);
